import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { HistoryCard } from '../../models/content-vehicle-history-drawer.model';
import { convertSecondsToTimeString } from 'src/app/vehicles/components/content-panel-vehicles/helpers/convert-seconds-to-time-string';
import { roundToTwoDecimals } from '../../helpers/format-dates.helper';

@Component({
  selector: 'card-history',
  templateUrl: './history-card.component.html',
  styleUrls: ['./history-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoryCardComponent {
  @Input() history: HistoryCard = {
    name: '',
    imei: '',
    date: '',
    totalDistance: 0,
    totalTimeOn: 0,
    totalTimeOff: 0,
    avgSpeed: 0,
    totalStops: 0,
    totalMovements: 0,
  };
  @Output() deleteHistory = new EventEmitter<string>();
  @Output() showHistory = new EventEmitter<string>();

  handleDeleteHistory(event: Event) {
    event.stopPropagation();
    this.deleteHistory.emit(this.history.imei);
  }

  handleShowHistory(event: Event) {
    event.stopPropagation();
    this.showHistory.emit(this.history.imei);
  }

  convertSecondsToTimeString(seconds: number): string {
    return convertSecondsToTimeString(seconds, {
      shortFormat: true,
      showZeros: false,
    });
  }

  roundToTwoDecimals(value: number): string {
    return roundToTwoDecimals(value);
  }
}
